/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ExportCommentsWidget_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportCommentsWidget_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "withWidgetData_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/components/ExportCommentsWidget/__generated__/ExportCommentsWidget_surveys.graphql.js